import moment from 'moment-timezone';

export const timeZones = {
  AmericaBogota: 'America/Bogota'
};

const formatSearch = word => word.replaceAll(' ', '').toLowerCase();

const stringToBuffer = str => {
  const buffer = new ArrayBuffer(str.length);
  const bufferView = new Uint8Array(buffer);
  for (let i = 0; i < str.length; i++) {
    bufferView[i] = str.charCodeAt(i);
  }
  return buffer;
};

const bufferToString = buffer => String.fromCharCode.apply(null, new Uint8Array(buffer));

const utils = {
  statusEmailMarketing: {
    NOTCOMPLETEREGISTER: 'STATUS#NOTCOMPLETEREGISTER',
    FIRSTPAY: 'STATUS#FIRSTPAY'
  },
  dateToSendEmailMarketing: (status, daysToSend = 3) => ({
    GSI1PK: status,
    GSI1SK: `DATE#${
      process.env.NODE_ENV === 'production' ? moment().add(daysToSend, 'days').format('YYYYMMDD') : moment().format('YYYYMMDD')
    }`,
    countSendEmailMarketing: 0
  }),
  getLast4Digit: numero => {
    const numeroStr = numero.toString();

    return numeroStr.slice(-4);
  },
  moneyFormat: (value, currency = 'COP', language = 'es-CO') => {
    const options = { style: 'currency', currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0 };
    const numberFormat = new Intl.NumberFormat(language, options);
    const formatedValue = numberFormat.format(Number(value));
    return `${formatedValue} ${currency}`;
  },
  isEmail: email => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email),
  businessTimeZone: 'America/Bogota',
  valueLabelListToLabelsObject: list => list.reduce((prev, { value, label }) => ({ ...prev, [value]: label }), {}),
  getLoadedFileData: file =>
    new Promise(resolve => {
      const result = { fileURL: null, fileExtension: null };
      result.fileExtension = file.type.split('/')[1];
      const reader = new FileReader();
      reader.onload = () => {
        result.fileURL = reader.result;
        resolve(result);
      };
      reader.onerror = error => {
        resolve(result);
        process.env.NODE_ENV === 'development' && console.log('Error reading file', error);
      };
      reader.readAsDataURL(file);
    }),

  filterBySearch: (search, words) => {
    if (!search) return true;
    const joinedWords = formatSearch(words.join(''));
    const formatedSearch = formatSearch(search);
    return joinedWords.includes(formatedSearch);
  },
  filtersBySearch: (searchs, words) => {
    const joinedWords = formatSearch(words.join(''));
    return searchs.length !== 0 ? searchs.some(search => joinedWords.includes(formatSearch(search))) : true;
  },
  toDate: date => moment(date).startOf('day').format('YYYY-MM-DD'),
  toDateEnd: date => (moment(date).isValid() ? moment(date).endOf('day') : new Date()),
  deepCopy: data => JSON.parse(JSON.stringify(data)),
  encryptText: async textToEncrypt => {
    const pem = atob(process.env.REACT_APP_CRYPTO_PUBLIC_KEY_BASE64);
    const pemHeader = '-----BEGIN PUBLIC KEY-----';
    const pemFooter = '-----END PUBLIC KEY-----';
    const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length - 1);
    const pemBinary = atob(pemContents);
    const pemBuffer = stringToBuffer(pemBinary);
    const encriptedBuffer = await crypto.subtle.encrypt(
      { name: 'RSA-OAEP' },
      await window.crypto.subtle.importKey('spki', pemBuffer, { name: 'RSA-OAEP', hash: 'SHA-256' }, true, ['encrypt']),
      stringToBuffer(textToEncrypt)
    );
    return btoa(bufferToString(encriptedBuffer));
  },
  downloadFileByUrl: async (url) => {
    try {
      // Verificar si es una URL de S3 firmada
      if (url.includes('amazonaws.com') && url.includes('X-Amz-Signature')) {
        // Para URLs firmadas de S3, usar fetch para descargar el archivo
        const response = await fetch(url, {
          method: 'GET',
          mode: 'cors',
        });
        
        if (!response.ok) {
          throw new Error(`Error al descargar el archivo: ${response.status} ${response.statusText}`);
        }
        
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        
        // Crear enlace de descarga
        const alink = document.createElement('a');
        alink.href = downloadUrl;
        alink.download = 'comprobante-cobro.pdf'; // Nombre por defecto
        document.body.appendChild(alink);
        alink.click();
        document.body.removeChild(alink);
        
        // Limpiar la URL del objeto
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        // Para URLs normales, usar el método original
        const alink = document.createElement('a');
        alink.href = url;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        document.body.appendChild(alink);
        alink.click();
        document.body.removeChild(alink);
      }
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      // Fallback al método original si falla
      const alink = document.createElement('a');
      alink.href = url;
      alink.target = '_blank';
      alink.rel = 'noopener noreferrer';
      document.body.appendChild(alink);
      alink.click();
      document.body.removeChild(alink);
    }
  },
  sleep: timeInMilliseconds => new Promise(resolve => setTimeout(resolve, timeInMilliseconds)),
  promiseLoop: async (processPromise, resultProcessing, options) => {
    const MAX_ITERATIONS = 10;
    const INITIAL_CURRENT_TIME = 2000;

    let currentTime = options?.initialCurrentTime || INITIAL_CURRENT_TIME;
    let isProcessFinished = false;
    let currentIteration = 0;

    const maxIterationsToUse = options?.maxIterations || MAX_ITERATIONS;

    while (!isProcessFinished && currentIteration < maxIterationsToUse) {
      const response = await processPromise();
      const result = await resultProcessing(response);
      isProcessFinished = result.isProcessFinished;

      if (!isProcessFinished) {
        await utils.sleep(currentTime);
        currentTime *= 2;
        currentIteration += 1;
      }
    }

    return { maxIterationsReached: currentIteration === maxIterationsToUse };
  }
};

export default utils;
